import React, { Fragment } from 'react'
import { translate } from '../Services/translation'
import { format } from '../Services/strings'
import MiniCartOrderRow from './MiniCartOrderRow'

const getOrderRowElements = ({
    orderRows,
    removeOrderRow,
    updateOrderRowQuantity,
}) => {
    const orderRowElements = orderRows.map((row) => (
        <MiniCartOrderRow
            orderRow={row}
            removeOrderRow={removeOrderRow}
            updateOrderRowQuantity={updateOrderRowQuantity}
            key={row.rowSystemId}
        />
    ))

    return <div className="cart__info-order-rows">{orderRowElements}</div>
}

const getCartContent = ({
    quantity,
    orderTotal,
    checkoutUrl,
    removeOrderRow,
    updateOrderRowQuantity,
    orderRows,
}) => {
    if (quantity === '0') {
        return (
            <div className="cart__info-empty-text">
                {translate('minicart.empty')}
            </div>
        )
    }

    return (
        <Fragment>
            {getOrderRowElements({
                removeOrderRow,
                updateOrderRowQuantity,
                orderRows,
            })}
            <div className="cart__info-row-bottom">
                <hr className="small-12 cart__separator" />
                <div className="cart__info-row cart__flex cart__info-row--summary">
                    <div>{translate('minicart.total')}</div>
                    <div className="cart__info-row--order-total">
                        {orderTotal}
                    </div>
                </div>
                <div className="cart__checkout-button-section">
                    <a href={checkoutUrl} className="cart__checkout-button">
                        {translate('minicart.checkout')}
                    </a>
                </div>
            </div>
        </Fragment>
    )
}

const MiniCart = ({
    quantity,
    orderTotal,
    orderRows,
    checkoutUrl,
    showInfo,
    toggle,
    removeOrderRow,
    updateOrderRowQuantity,
}) => {
    return (
        <Fragment>
            <a
                href="#!"
                onClick={() => toggle()}
                title={translate('minicart.title')}
            >
                <i className="cart__icon icon-bag"></i>
                <span className="cart__quantity">{quantity}</span>
            </a>
            <div
                className={`cart__info ${
                    !showInfo ? 'cart__info--hidden' : ''
                }`}
            >
                <div className="cart__header">
                    <div className="cart__header-text">
                        {translate('minicart.cart')}
                    </div>
                    <div
                        className="cart__close-button icon-close"
                        onClick={() => toggle()}
                    ></div>
                </div>
                <hr className="small-12 cart__separator" />
                {getCartContent({
                    quantity,
                    orderTotal,
                    checkoutUrl,
                    removeOrderRow,
                    updateOrderRowQuantity,
                    orderRows,
                })}
            </div>
            <div
                className={`cart__backdrop ${
                    !showInfo ? 'cart__backdrop--hidden' : ''
                }`}
                onClick={() => toggle()}
            ></div>
        </Fragment>
    )
}

export default MiniCart
